

import routeMixin from '~/mixins/routeMixin';
import respUtility from '~/mixins/respUtility';

export default {
  name: 'BrandPage',
  mixins: [routeMixin, respUtility],
  data: () => ({
  }),
  head() {
    return {
      script: [
        {
          src: 'https://static.criteo.net/js/ld/ld.js',
          async: true,
          skip: !this.$config.criteo.criteoDefaultEnable,
        },
      ],
    };
  },
  computed: {
    breadcrumbs() {
      const breadcrumbs = [...(this.$store.state.metaData?.addons?.breadcrumbs || [])];
      if (breadcrumbs[0]) {
        breadcrumbs[0] = { ...breadcrumbs[0], isInternal: true };
      }
      return breadcrumbs;
    },
  },
};

